import styled from 'styled-components';

export const ResultsContainer = styled.div`
    margin-top: 16px;
`;

export const Card = styled.div`
    border: ${({ theme }) => `1px solid ${theme.tokens.BaseColorGray300}`};
    padding: 16px;
    background-color: white;
    cursor: pointer;
    margin-top: -1px;
    &.active {
        background-color: ${({ theme }) => `${theme.tokens.BaseColorBlue50}`};
        border-left-width: 4px;
        border-left-color: ${({ theme }) => `${theme.tokens.BaseColorBlue900}`};
        border-radius: 4px 0px 0px 0px;
    }
`;

/* The actions line up with the required-field inputs above rather than sitting at their own content width, which is
   how the result row's slot behaves. Basis auto so a button never shrinks under its label and loses its horizontal
   padding; wrapping is what gives when the pair cannot fit. */
export const NotInStockVehicleActions = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 16px;

    > * {
        flex: 1 1 auto;
    }
`;

export const NotInStockVehicleDataContainer = styled.div`
    padding-top: 16px;
`;
